import styled from 'styled-components';

export const S = {
  Link: styled.a<{
    $color: string;
    $underline: boolean;
  }>`
    color: ${(props) => props.$color};
    cursor: pointer;
    text-decoration: ${(props) => (props.$underline ? 'underline' : 'none')};
  `
};
